
import Checklist from 'vux/src/components/checklist/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import XNumber from 'vux/src/components/x-number/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import VueUploadComponent from 'vue-upload-component'
export default {
name: 'month_form',
components: {
Checklist,
Range,
Rater,
XAddress,
XNumber,
XSwitch,
XTextarea,
XButton,
Grid,
GridItem,
Previewer,
FileUpload: VueUploadComponent
},
directives: {
TransferDom
},
data() {
return {
a: 1,
files: [],
imgUploadItem: [], //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
id: this.$route.query.id,
commonList: ['China', 'Japan', 'America'],
checklist002: ['China', 'Japan'],

list1: [['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']],
value1: ['iPhone'],

date: '',
data1: 0,
data3: 5,

addressValue: [],
addressData: ChinaAddressV4Data,

numberValue: 12,
switchValue: '1',

showSignature: true,
showCSignature: true,
option: {
penColor: 'rgb(0, 0, 0)'
},
selectText: '',
selectTextItem: 'submit',
signDialog: false
}
},
methods: {
goBack() {
this.$router.push({
path: './maternal_service',
query: {
tabVal: this.$route.query.tabVal,
id: this.$route.query.id
}
})
},
editName() {
this.showSignature = false

},
edit() {},
selectTextHandle() {

this.selectText = this.selectText + this.selectTextItem
},
inputFile: function(newFile, oldFile) {
if (newFile && oldFile && !newFile.active && oldFile.active) {

console.log('response', newFile.response)
if (newFile.xhr) {

console.log('status', newFile.xhr.status)
}
}
},
inputFilter: function(newFile, oldFile, prevent) {
if (newFile && !oldFile) {

if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
return prevent()
}
}


newFile.blob = ''
let URL = window.URL || window.webkitURL
if (URL && URL.createObjectURL) {
newFile.blob = URL.createObjectURL(newFile.file)

this.imgUploadItem.push({
src: newFile.blob,
index: this.imgUploadItem.length + 1
})
}
},

previewImage(index) {
this.$refs.previewer.show(index)
},

deleteImgHandle(item) {
this.imgUploadItem = this.imgUploadItem.filter(function(tmp) {
return tmp.index != item.index
})
},
signImageClear() {
const sigRef = this.$refs['signature']
if (Array.isArray(sigRef)) {
sigRef.forEach(c => c && c.clear && c.clear())
} else if (sigRef && sigRef.clear) {
sigRef.clear()
}
this.form.into_intermediate_nurse_sign = ''
},
fullScreenSign() {
this.signDialog = true
},
clearCName() {
let signature = 'signature'
const sigRef = this.$refs[signature]
if (Array.isArray(sigRef)) {

sigRef.forEach(c => c && c.clear && c.clear())
} else if (sigRef && sigRef.clear) {
sigRef.clear()
}
this.form.into_intermediate_nurse_sign = ''
},
saveCName() {
let signature = 'signature'
const sigRef = this.$refs[signature]

const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
let png = comp && comp.save ? comp.save() : ''
let bold = Util.dataURItoBlob(png)
this.signDialog = false
}
},
created() {
if (this.$route.query.a) {
this.a = this.$route.query.a
}
}
}



// WEBPACK FOOTER //
// ./src/components/design/form.vue